import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import BibliothequeAdmin from "./admin/BibliothequeAdmin";

export default function EspaceLibraire() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  if (!user) return <Navigate to="/connexion" replace />;
  if (!user.is_admin && !user.is_libraire) {
    return (
      <div className="container">
        <div className="error">Accès réservé aux libraires.</div>
      </div>
    );
  }

  const doLogout = async () => { await logout(); nav("/"); };

  return (
    <div className="container">
      <div style={{ display: "flex", justifyContent: "space-between",
                    alignItems: "baseline", flexWrap: "wrap", gap: "1rem" }}>
        <h1>Espace libraire</h1>
        <div className="muted">
          {user.prenom} {user.nom}
          {user.is_admin && <span style={{ marginLeft: 8 }}>🛡 Admin</span>}
          {user.is_libraire && <span style={{ marginLeft: 8 }}>📚 Libraire</span>}
          <button className="secondary small" style={{ marginLeft: "1rem" }} onClick={doLogout}>
            Déconnexion
          </button>
        </div>
      </div>
      <BibliothequeAdmin />
    </div>
  );
}
